import { render } from "./button_setting.vue?vue&type=template&id=4c724546&scoped=true"
import script from "./button_setting.vue?vue&type=script&lang=js"
export * from "./button_setting.vue?vue&type=script&lang=js"

import "./button_setting.vue?vue&type=style&index=0&id=4c724546&scoped=true&lang=css"
import "./button_setting.vue?vue&type=style&index=1&id=4c724546&lang=css"
import "./button_setting.vue?vue&type=style&index=2&id=4c724546&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c724546"]])

export default __exports__